import React, { Component } from 'react'
import TransparentLoadIndicator from "Components/Common/transparentLoadIndicator";

export default class SettingsButton extends Component {
    constructor(props) {
        super(props);

        this.buttonText = "Профиль";
    }    

    GetNormalPart() {
        if (this.props.processInfo.status !== 1 && this.props.processInfo.task !== 13) {
            return this.buttonText;
        } else {
            return (<TransparentLoadIndicator processInfo={this.props.processInfo} />);
        }
    }

    render() {
        return (
            <button className='settings-button'>
                <div className='settings-button-main-part'>
                    { this.GetNormalPart() }
                </div>
                <div className='settings-button-hovered-part'>
                    {this.buttonText}
                </div>
            </button>
        )
    }
}